import { Injectable } from "@angular/core";
import { LgFilterSet } from "@logex/framework/lg-filterset";

@Injectable({ providedIn: "root" })
export class LastFilterStorageService {
    private state: _.Dictionary<string>;

    constructor() {
        this.state = {};
    }

    storeInMemory(currentState: _.Dictionary<string>): void {
        this.state = currentState;
    }

    // the method should be removed once a bug in FW will be fixed
    // the issue in desirialization of values for input range filter
    populateFilterFromMemory(filterSet: LgFilterSet): void {
        for (const filter in filterSet.filters) {
            if (
                Object.prototype.hasOwnProperty.call(filterSet.filters, filter) &&
                Object.prototype.hasOwnProperty.call(this.state, filter)
            ) {
                const definition = filterSet.getFilterDefinition(filter);

                if (definition.filterType === "inputRange") {
                    filterSet.filters[definition.storage] = JSON.parse(this.state[filter]);
                } else {
                    filterSet.getRenderer(filter).deserialize(this.state[filter]);
                }
                filterSet.triggerOnChanged(filter);
            }
        }
    }

    getFromMemory(): _.Dictionary<string> {
        return this.state;
    }

    storeInLocalStorage(key: string, filter: _.Dictionary<string>): void {
        localStorage.setItem(key, JSON.stringify(filter));
    }

    extractFromLocalStorage(key: string | null): _.Dictionary<string> | null {
        if (key) {
            const value = localStorage.getItem(key);
            if (value != null) {
                localStorage.removeItem(key);
                return JSON.parse(value);
            }
        }
        return null;
    }

    clearStorage(): void {
        localStorage.clear();
    }
}
